/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {PersonDtoModel} from '@well/domain';
import {
  customRequiredValidation,
  ErrorModel,
  MAXIMUM_DEFAULT_STRING_INPUT_LENGTH
} from '@irian-ro/shared-components-module';
import {FormControl, FormGroup} from '@angular/forms';
import { FormUtils } from "@irian-ro/util-forms";

@Component({
  selector: 'well-person-inputs',
  templateUrl: './person-inputs.component.html',
  styleUrls: ['./person-inputs.component.scss']
})
export class PersonInputsComponent implements OnInit {
  @Output() save: Subject<PersonDtoModel> = new Subject();
  @Input() person: PersonDtoModel | null = null;
  errors: Array<ErrorModel> = [];
  form: FormGroup | undefined = undefined;

  @Input() set disabled(value: boolean) {
    if (value) {
      this.form?.disable();
    } else {
      this.form?.enable();
    }
  }

  private _showOnlyName = false;
  @Input() set showOnlyName(value: boolean) {
    this._showOnlyName = value;
    if (this._showOnlyName) {
      this.disableAllFieldsExceptName();
      this.countyFormControl.setValidators(null);
    }
  }

  get showOnlyName(): boolean {
    return this._showOnlyName;
  }

  constructor() {
    this.form = this.createForm();
  }

  get nameFormControl() {
    return this.form?.get('name') as FormControl;
  }

  get addressFormControl() {
    return this.form?.get('address') as FormControl;
  }

  get countyFormControl() {
    return this.form?.get('county') as FormControl;
  }

  get countryFormControl() {
    return this.form?.get('country') as FormControl;
  }

  ngOnInit() {
    if (this.person) {
      this.form?.patchValue(this.person);
      this.form?.updateValueAndValidity();
    }
  }

  onSubmit() {
    if(this.form) {
      FormUtils.markAllAsTouched(this.form);
      FormUtils.markAllAsDirty(this.form);
    }

    this.form?.updateValueAndValidity({emitEvent: true});

    if (this.form?.valid) {
      this.save.next(this.form.getRawValue());
    }
  }

  private disableAllFieldsExceptName() {
    this.addressFormControl.disable();
    this.countyFormControl.disable();
  }

  private createForm() {
    return new FormGroup({
      uuid: new FormControl(null),
      name: new FormControl(null, customRequiredValidation('Name')),
      address: new FormControl(null),
      county: new FormControl(null),
      country: new FormControl(null),
    });
  }

  protected readonly MAXIMUM_DEFAULT_STRING_INPUT_LENGTH = MAXIMUM_DEFAULT_STRING_INPUT_LENGTH;
}

